export default __webpack_public_path__ + "static/media/telegram.6e6e1957.svg";